export const timeSlotsStepLoadingWrapperStyles = {
	display: 'grid',
	gridTemplateColumns: '1fr 1fr 1fr',
	columnGap: '16px',
	rowGap: '32px',
	padding: '16px 0',
};

export const timeSlotsStepLoadingChip = { width: '100%', height: 'initial', padding: '8px 0' };

export const timeSlotsStepLoadingChipContent = { filter: 'blur(3px)' };
